"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SectionTitlePropTypes = exports.RenderSectionPropTypes = exports.MobileDropdownPropTypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("../Theme/constant");

var _constant2 = require("./constant");

var optionObject = {
  title: _propTypes.default.string.isRequired,
  subtitle: _propTypes.default.string,
  value: _propTypes.default.any.isRequired
};
var optionsConfigObject = {
  icon: _propTypes.default.string,
  iconColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
  titleColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
  subtitleColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
  bold: _propTypes.default.bool,
  separator: _propTypes.default.bool
};
var sectionConfigObject = {
  sectionHeaderConfig: _propTypes.default.shape({
    sectionHeaderColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
    sectionTitleColor: _propTypes.default.oneOf(_constant.ARR_COLORS)
  }),
  sectionHeaderLabel: _propTypes.default.string,
  optionsConfig: _propTypes.default.shape(optionsConfigObject),
  sectionColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
  options: _propTypes.default.arrayOf(_propTypes.default.shape(optionObject))
};
var customPropertiesObject = {
  header: _propTypes.default.object,
  Options: _propTypes.default.object,
  sections: _propTypes.default.object,
  dropdown: _propTypes.default.object
};
var MobileDropdownPropTypes = {
  PropTypes: {
    headerConfig: _propTypes.default.shape({
      iconColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
      theme: _propTypes.default.string,
      backgroundColor: _propTypes.default.oneOf(_constant.ARR_BACKGROUND_COLORS),
      labelColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
      bold: _propTypes.default.bool
    }),
    headerLabel: _propTypes.default.string.isRequired,
    onHeaderIconClick: _propTypes.default.func,
    sections: _propTypes.default.arrayOf(_propTypes.default.shape(sectionConfigObject)),
    defaultSelectedOption: _propTypes.default.string,
    onOptionPress: _propTypes.default.func,
    theme: _propTypes.default.string,
    customProperties: _propTypes.default.shape(customPropertiesObject),
    showHeader: _propTypes.default.bool,
    showSectionHeaderLabel: _propTypes.default.bool,
    idConfig: _propTypes.default.exact({
      widgetName: _propTypes.default.string,
      parentName: _propTypes.default.string,
      index: _propTypes.default.string
    })
  },
  DefaultProps: {
    backgroundColor: 'default',
    labelColor: _constant2.LABEL_COLOR,
    bold: true,
    theme: _constant.DEFAULT_THEME,
    onOptionPress: function onOptionPress() {},
    defaultSelectedOption: {},
    customProperties: {
      header: {},
      Options: {},
      sections: {},
      dropdown: {}
    },
    showHeader: true,
    showSectionHeaderLabel: true
  }
};
exports.MobileDropdownPropTypes = MobileDropdownPropTypes;
var RenderSectionPropTypes = {
  PropTypes: {
    sectionConfig: _propTypes.default.shape(sectionConfigObject),
    sectionHeaderLabel: _propTypes.default.string,
    optionsConfig: _propTypes.default.shape(optionsConfigObject),
    sectionColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
    options: _propTypes.default.arrayOf(_propTypes.default.shape(optionObject)),
    markSelectedOnPress: _propTypes.default.func,
    selectedItem: _propTypes.default.string,
    theme: _propTypes.default.string,
    customProperties: _propTypes.default.shape(customPropertiesObject)
  }
};
exports.RenderSectionPropTypes = RenderSectionPropTypes;
var SectionTitlePropTypes = {
  PropTypes: {
    sectionHeaderConfig: _propTypes.default.shape({
      sectionHeaderColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
      sectionTitleColor: _propTypes.default.oneOf(_constant.ARR_COLORS)
    }),
    sectionHeaderLabel: _propTypes.default.string,
    theme: _propTypes.default.string
  },
  DefaultProps: {
    sectionHeaderConfig: {
      sectionHeaderColor: 'primary',
      sectionTitleColor: 'greyDarker'
    }
  }
};
exports.SectionTitlePropTypes = SectionTitlePropTypes;